import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { MODULE_HIGHLIGHTS } from "./landing-data";

export function LandingModules() {
  return (
    <section
      id="moduler"
      className="scroll-mt-24 bg-slate-50 py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:items-center lg:gap-16">
          <div>
            <p className="text-sm font-semibold uppercase tracking-wider text-sky-600">
              Moduler
            </p>
            <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Slå på det dere trenger — ikke mer
            </h2>
            <p className="mt-4 text-lg text-slate-600">
              Promang er modulært. Start med prosjekter og service, legg til
              kvalitet, timer, lager eller HMS når organisasjonen er klar. Hver
              bedrift får sin egen konfigurasjon.
            </p>
            <ul className="mt-8 space-y-3">
              {[
                "Rollebasert tilgang per modul",
                "Dokumenter og media på tvers av moduler",
                "Mobil og desktop — samme data",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-slate-700">
                  <CheckCircleIcon
                    className="mt-0.5 h-5 w-5 shrink-0 text-sky-500"
                    aria-hidden
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-12 lg:mt-0">
            <div className="flex flex-wrap gap-2">
              {MODULE_HIGHLIGHTS.map((mod) => (
                <span
                  key={mod}
                  className="inline-flex items-center rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm transition hover:border-sky-300 hover:text-sky-700"
                >
                  {mod}
                </span>
              ))}
              <span className="inline-flex items-center rounded-full border border-dashed border-slate-300 px-4 py-2 text-sm text-slate-500">
                + flere moduler
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
